// @flow
import React, { Component } from 'react';

import {
  StreamApp,
  StatusUpdateForm,
  FlatFeed,
  Activity,
  LikeButton,
  CommentField,
  CommentList,
  CommentItem,
  InfiniteScrollPaginator,
  Streami18n,
} from 'react-activity-feed';

import 'react-activity-feed/dist/index.css';

const axios = require('axios').default;
const search = window.location.search;
const params = new URLSearchParams(search);
const liftApiUrl = params.get('api_url');
const webToken = params.get('lift_token');
const club = params.get('user_club');
const challengeId = params.get('challenge_id');
const token = params.get('user_token');
const userId = params.get('user_id');
const apiKey = params.get('api_key');
const appId = params.get('app_id');
const feedId = params.get('feed_id');
const lang = params.get('lang') ? params.get('lang') : 'en';
const i18n = new Streami18n({ language: lang });
const instance = axios.create({
  baseURL: liftApiUrl,
  timeout: 3000,
  headers: {'Club': club},
  headers: {'LIFT-WEB-TOKEN': webToken},
});

function deleteActivity(activity) {
	// console.log('Trying to remove activity: ' + activity.id + ' for user ' + activity.actor.id);
	
	instance
		.delete('challenge/' + challengeId + '/activityFeed/feedUserId/' + userId + '/activity/' + activity.id)
		.then(() => {
			document.location.href = document.location.href;
		})
		.catch(error => {
			console.error(error);
		});
}

function deleteComment(activity, comment) {
	// console.log('Trying to remove comment: ' + comment.id + ' on activity ' + activity.id + ' for user ' + comment.user_id);
	
	instance
		.delete('challenge/' + challengeId + '/activityFeed/feedUserId/' + userId + '/activity/' + activity.id + '/comment/' + comment.id)
		.then(() => {
			document.location.href = document.location.href;
		})
		.catch(error => {
			console.error(error);
		});
}

export default class App extends Component {
  containerRef = React.createRef();

  render() {
    return (
      <div
        ref={this.containerRef}
		style={{backgroundColor: '#f4f4f4'}}
      >

        <StreamApp apiKey={apiKey} appId={appId} token={token} i18nInstance={i18n}>
          <StatusUpdateForm
            feedGroup="global"  //user, timeline or notification
            userId={feedId}
          />
          <FlatFeed
            feedGroup="global"  //user, timeline or notification
            userId={feedId}
            notify
            options={{ ranking: 'Pinning', limit: 100, withOwnChildren: true, withRecentReactions: true, withOwnReactions: true }}
            Paginator={(paginatorProps) => (
              <InfiniteScrollPaginator
                useWindow={false}
                threshold={5}
                {...paginatorProps}
                getScrollParent={() => this.containerRef}
              />
            )}
            Activity={(activityProps) => (
				<Activity
                {...activityProps}
                Footer={() => (
                  <React.Fragment>
                    {activityProps.activity.actor.id == userId &&
	                    <div className='btn--group'>
		                    <button className='btn-delete--activity' onClick={() => deleteActivity(activityProps.activity)}>
		                      {lang != 'fr' && 'Delete'}
		                      {lang == 'fr' && 'Effacer'}
		                    </button>
	                    </div>
                    }
					<div className='like-container--post'>
						<LikeButton
							activity={activityProps.activity}
							reactionKind="like" 
							{...activityProps}
						/>
					</div>
					<div className='comment-container--post' >
	                    <CommentList
	                      activityId={activityProps.activity.id}
	                      CommentItem={(commentProps) => (
	                        <React.Fragment>
	                          <CommentItem {...commentProps} />
                    		  {commentProps.comment.user_id == userId &&
                            	<div className='btn--group'>
                            		<button className='btn-delete--activity' onClick={() => deleteComment(activityProps.activity, commentProps.comment)}>
				                      {lang != 'fr' && 'Delete'}
				                      {lang == 'fr' && 'Effacer'}
                          			</button>
                          		</div>
                          	  }
	                          <LikeButton
	                          	reaction={commentProps.comment}
	                          	reactionKind="like"
	                          	{...commentProps}
	                          />
	                        </React.Fragment>
	                      )}
	                    />
	                    <CommentField
	                      activity={activityProps.activity}
	                      onAddReaction={activityProps.onAddReaction}
	                    />
					</div>
                  </React.Fragment>
                )}
              />
            )}
          />
        </StreamApp>
      </div>
    );
  }
  
}
